import CaladreTheme from "theme/Theme";
import sharedStyle from "../style";

const classes = {
  ...sharedStyle,
  fichePays: {
    "& .MuiImageList-root ": {
      gap: "10px !important",
      margin: 0,
      width: "100%",
      height: "100%",
      "& .MuiImageListItem-root:hover": {
        cursor: "pointer",
      },
      "& .MuiImageListItem-root:first-child img": {
        borderTopLeftRadius: "15px",
        borderBottomLeftRadius: "15px",
      },
      "& .MuiImageListItem-root:nth-of-type(3) img": {
        borderTopRightRadius: "15px",
      },
      "& .MuiImageListItem-root:last-child img": {
        borderBottomRightRadius: "15px",
      },
    },
  },
};
export default classes;
